<template>
	<div class="official-recommend-page">
		<div class="content-container">
			<div class="filterBox">
				<div class="searchBox">
					<input type="text" v-model="title" placeholder="请输入要寻找的商品名称关键字…" />
					<div class="search" @click="goodsList">搜索</div>
				</div>
				<div class="filterTitle">市场筛选</div>
				<div class="filterItem">
					<div class="filterItemTitle">类型({{total}})：</div>
					<div class="filterItemList">
						<div class="tip" :class="cid == '' ? 'active' : ''" @click="changeType('cid',{id: ''})">全部</div>
						<div class="tip" :class="cid == item.id ? 'active' : ''" v-for="(item,index) in goodsCates"
							:key="index" @click="changeType('cid',item)">{{item.title}}</div>
					</div>
				</div>
				<div class="filterItem">
					<div class="filterItemTitle">排列方式：</div>
					<div class="filterItemList">
						<div class="tip" :class="px == item.value ? 'active' : ''" v-for="(item,index) in sortOpts"
							:key="index" @click="changeType('px',item)">{{item.title}}</div>
					</div>
				</div>
			</div>
			<div class="officialList">
				<div class="officalItem" v-for="(item,index) in goodsData" :key="index"
					@click="$router.push({path: '/markets-details',query:{id:item.id}})">
					<img class="itemImg" :src="item.img" />
					<div class="itemOther">
						<div class="itemTitle ellipsis-1">{{item.title}}</div>
						<div class="priceSale">
							<div class="price">
								<span class="unit">¥</span>
								{{item.original_price}}
							</div>
							<div class="sale">已售 {{item.buy_count}}+</div>
						</div>
						<div class="make">立即定制
						</div>
					</div>
				</div>
			</div>
			<!-- 分页控件 -->
			<PagePagination style="padding: .32rem 0 .8rem;" :currentPage="currentPage" :total="total"
				@current-change="onPageChange" />
		</div>
	</div>
</template>

<script>
	export default {
		name: 'SurroundingMarkets',
		data() {
			return {
				px: '',
				cid: '',
				title: '',
				goodsData: [],
				currentPage: 1, // 当前页码
				total: 0, // 总条数
				goodsCates: [],
				sortOpts: [{
					title: '默认',
					value: ''
				}, {
					title: '销量优先',
					value: '1'
				}, {
					title: '价格升序',
					value: '2'
				}, {
					title: '价格降序',
					value: '3'
				}],
			}
		},
		mounted() {
			this.goodsList()
			this.goodsClassify()
		},
		methods: {
			// 页码变化处理
			onPageChange(newPage) {
				this.currentPage = newPage
				// 这里添加实际的数据加载逻辑
				console.log(`切换到第${newPage}页`)
			},
			goodsClassify() {
				this.$api.post('/Goods/goods_classify', {
					id: this.$route.query.userId
				}).then(res => {
					if (res.code == 1) {
						this.goodsCates = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			goodsList() {
				let params = {}
				if (this.px == '') {
					params.px_price = ''
					params.px_new = ''
					params.px_buy = ''
				} else if (this.px == '1') {
					params.px_price = ''
					params.px_new = ''
					params.px_buy = '1'
				} else if (this.px == '2') {
					params.px_price = '1'
					params.px_new = ''
					params.px_buy = ''
				} else if (this.px == '3') {
					params.px_price = '2'
					params.px_new = ''
					params.px_buy = ''
				}
				this.$api.post('/Goods/goods_list', {
					...params,
					cid: this.cid,
					title: this.title
				}).then(res => {
					if (res.code == 1) {
						this.goodsData = res.data.list
						this.total = res.data.count
					}
				}).catch(err => {
					console.log(err);
				})
			},
			changeType(type, item) {
				if (type == 'cid') {
					this.cid = item.id
				} else if (type == 'px') {
					this.px = item.value
				}
				this.goodsList()
			}
		}
	}
</script>

<style lang="scss" scoped>
	.official-recommend-page {
		display: flex;
		flex-direction: column;
		align-items: center;
		background: #FDFDF4;
		min-height: 100vh;
	}

	.content-container {
		width: 12rem;
		display: flex;
		flex-direction: column;
	}

	.filterBox {
		margin-top: .48rem;
		display: flex;
		flex-direction: column;
		width: 12rem;
		background: #FFFFFF;
		box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
		border-radius: .12rem;
		padding: 0 0 .24rem .32rem;

		.searchBox {
			margin: .24rem auto;
			display: flex;
			align-items: center;
			border-radius: .06rem;
			border: 0.01rem solid #E29358;
			width: 5.9rem;
			height: .4rem;

			input {
				width: 4.9rem;
				height: .38rem;
				margin-left: .12rem;
				padding: 0 0;
				border: none;
				font-weight: 400;
				font-size: .14rem;
			}

			.search {
				width: .88rem;
				height: .4rem;
				background: #E29358;
				box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
				border-radius: 0 .06rem .06rem 0;
				font-weight: 400;
				font-size: .14rem;
				color: #252525;
				line-height: .4rem;
				text-align: center;
				cursor: pointer;
			}
		}

		.filterTitle {
			font-weight: 500;
			font-size: .14rem;
			color: #000000;
		}

		.filterItem {
			display: flex;
			font-size: .14rem;

			.filterItemTitle {
				margin-top: .16rem;
				height: .28rem;
				line-height: .28rem;
				width: .75rem;
				font-weight: 400;
				color: #000000;
			}

			.filterItemList {
				width: calc(100% - .75rem);
				display: flex;
				flex-wrap: wrap;

				.tip {
					margin-top: .16rem;
					margin-right: .24rem;
					height: .28rem;
					line-height: .28rem;
					font-weight: 400;
					color: #666666;
					cursor: pointer;

					&.active {
						color: #000000;
						padding: 0 .1rem;
						background: #E29358;
						box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
						border-radius: .06rem;
					}
				}
			}
		}
	}

	.officialList {
		width: 12rem;
		display: flex;
		flex-wrap: wrap;

		.officalItem:nth-child(4n) {
			margin-right: 0;
		}

		.officalItem {
			margin-top: .32rem;
			margin-right: .24rem;
			width: 2.82rem;
			background: #FFFFFF;
			box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
			border-radius: .12rem;
			overflow: hidden;
			cursor: pointer;

			.itemImg {
				width: 2.82rem;
				height: 2.82rem;
				object-fit: cover;
			}

			.itemOther {
				display: flex;
				flex-direction: column;
				padding: .24rem .16rem;

				.itemTitle {
					font-weight: 500;
					font-size: .24rem;
					color: #000000;
					line-height: .32rem;
				}

				.priceSale {
					margin-top: .16rem;
					display: flex;
					align-items: center;
					justify-content: space-between;

					.price {
						display: flex;
						align-items: baseline;
						font-weight: 700;
						font-size: .24rem;
						color: #FF0100;
						line-height: .24rem;

						.unit {
							margin-right: .04rem;
							font-size: .14rem;
						}
					}

					.sale {
						font-weight: 400;
						font-size: .16rem;
						color: #666666;
						line-height: .24rem
					}
				}

				.make {
					margin-top: .16rem;
					width: 2.50rem;
					height: .52rem;
					background: #E29358;
					border-radius: .06rem;
					font-weight: 500;
					font-size: .16rem;
					color: #252525;
					text-align: center;
					line-height: .52rem;
					cursor: pointer;
				}
			}
		}
	}
</style>